export enum Entity {
  //** CRM: **//
  agentCRMParent = 'agentCRMParent',
  agencyParent = 'agencyParent',
  registrantsParent = 'registrantsParent',
  prospectParent = 'prospectParent',
  registrationsConferencesParent = 'registrationsConferencesParent',
  campaignTaskBoardParent = 'campaignTaskBoardParent',
  campaignTaskGridParent = 'campaignTaskGridParent',
  reportStatusReportParent = 'reportStatusReportParent',
  reportEmailReportParent = 'reportEmailReportParent',
  notificationsCRMParent = 'notificationsCRMParent',
  carrierCrm = 'carrierCrm',

  // agentCRM = 'agentCRM', // removed
  agency = 'agency',
  prospect = 'prospect',
  registrants = 'registrants',

  emailDistributionLists = 'emailDistributionLists',
  emailTemplatesLists = 'emailTemplatesLists',

  registrationsConferences = 'registrationsConferences',
  registrationsWebinars = 'registrationsWebinars',
  registrationsContests = 'registrationsContests',

  campaignServices = 'campaignServices',
  campaignTaskBoard = 'campaignTaskBoard',
  campaignTaskGrid = 'campaignTaskGrid',

  reportStatusReport = 'reportStatusReport',
  reportRegistrationReport = 'reportRegistrationReport',
  reportEmailReport = 'reportEmailReport',
  reportChristmasCardList = 'reportChristmasCardList',
  reportFormsList = 'reportFormsList',

  administrationTaskListManager = 'administrationTaskListManager',
  administrationImportRulesManager = 'administrationImportRulesManager',
  administrationLookupsManager = 'administrationLookupsManager',
  administrationErrorsManager = 'administrationErrorsManager',
  administrationLogsManager = 'administrationLogsManager',
  administrationReportsManager = 'administrationReportsManager',
  administrationUserManager = 'administrationUserManager',
  administrationRoleManager = 'administrationRoleManager',
  administrationGoogleAuthManager = 'administrationGoogleAuthManager',
  administrationAuthStats = 'administrationAuthStats',
  administrationAuthIssuesAlerts = 'administrationAuthIssuesAlerts',
  administrationMergeTool = 'administrationMergeTool',
  administrationAddressesManagement = 'administrationAddressesManagement',
  administrationUserAgreementManagement = 'administrationUserAgreementManagement',

  // Agent Research Tool (read = search, write = upload/import)
  agentResearchTool = 'agentResearchTool',

  // Agent Registry / Agent IDs (read = view registry, write = mint / edit / retire)
  agentRegistry = 'agentRegistry',

  // Push Notifications
  notificationsCRM = 'notificationsCRM',
  notificationsPortal = 'notificationsPortal',
  notificationsTemplates = 'notificationsTemplates',
  notificationsChannels = 'notificationsChannels',
  notificationsScheduler = 'notificationsScheduler',
  notificationsBroadcastDelivery = 'notificationsBroadcastDelivery',
  dynamicListsAndSegmentsGroups = 'dynamicListsAndSegmentsGroups',
  dynamicSegmentsGroups = 'dynamicSegmentsGroups',
  dynamicListGroups = 'dynamicListGroups',
  emailTemplates = 'emailTemplates',

  // SubEntity:
  agentSalesGoal = 'agentSalesGoal',
  agentProspectStatusActivity = 'agentProspectStatusActivity',
  agentGenerateAgentId = 'agentGenerateAgentId',

  conferenceParent = 'conferenceParent',
  conference = 'conference',
  conferenceRegistrantsParent = 'conferenceRegistrantsParent',
  conferenceRegistrants = 'conferenceRegistrants',
  conferenceAttendeeDetails = 'conferenceAttendeeDetails',
  conferenceTransactions = 'conferenceTransactions',
  conferenceExcursionStatistic = 'conferenceExcursionStatistic',
  conferenceChangeLogs = 'conferenceChangeLogs',
  conferenceListAdmin = 'conferenceListAdmin',
  conferenceList = 'conferenceList',

  eventAttendeesOverallExcelReport = 'eventAttendeesOverallExcelReport',
  eventAttendeesCustomReports = 'eventAttendeesCustomReports',
  eventAttendeesMassMailing = 'eventAttendeesMassMailing',
  eventAttendeesSendEmailToQualifier = 'eventAttendeesSendEmailToQualifier',

  conferencePrimaryInfo = 'conferencePrimaryInfo',
  conferenceEmailSenderConfiguration = 'conferenceEmailSenderConfiguration',
  conferenceWelcomeInfo = 'conferenceWelcomeInfo',
  conferenceStepsConfiguration = 'conferenceStepsConfiguration',
  conferenceEmbeddedForm = 'conferenceEmbeddedForm',
  conferenceHotelInfo = 'conferenceHotelInfo',
  conferenceGuestsInfo = 'conferenceGuestsInfo',
  conferenceExcursionsInfo = 'conferenceExcursionsInfo',
  conferencePermissionsInfo = 'conferencePermissionsInfo',
  conferenceBulkOutcomeStatusUpdates = 'conferenceBulkOutcomeStatusUpdates',

  agentDisposition = 'agentDisposition',
  assignOwnerRegistrants = 'assignOwnerRegistrants',
  assignAgentIdRegistrants = 'assignAgentIdRegistrants',
  assignMGA = 'assignMGA',
  prospectStatusActivity = 'prospectStatusActivity',
  prospectWrapUp = 'prospectWrapUp',
  assignOwnerCampaign = 'assignOwnerCampaign',
  campaignsInfo = 'campaignsInfo',
  campaignsTaskIssues = 'campaignsTaskIssues',
  campaignsTaskLogs = 'campaignsTaskLogs',
  statusAppointmentScheduler = 'statusAppointmentScheduler',
  emailAppointmentScheduler = 'emailAppointmentScheduler',
  agencyManagementParent = 'agencyManagementParent',
  agencyManagement = 'agencyManagement',
  agentManagementParent = 'agentManagementParent',
  agentManagement = 'agentManagement',
  logAgencyNote = 'logAgencyNote',
  logAgentActivity = 'logAgentActivity',
  logAgentNote = 'logAgentNote',
  logAgencyMeeting = 'logAgencyMeeting',
  logAgentMeeting = 'logAgentMeeting',
  logAgencyCall = 'logAgencyCall',
  logAgentCall = 'logAgentCall',
  logAgentEmail = 'logAgentEmail',
  logAgencyEmail = 'logAgencyEmail',
  logAddAgentTask = 'logAddAgentTask',
  logAddAgencyTask = 'logAddAgencyTask',

  agentEditPicture = 'agentEditPicture',
  agencyEditPicture = 'agencyEditPicture',

  agencyAdminister = 'agencyAdminister',
  mgaSalesGoal = 'mgaSalesGoal',
  mgaSalesGoalCommentsAdministration = 'mgaSalesGoalCommentsAdministration',
  agencyHierarchyAdministration = 'agencyHierarchyAdministration',
  agencyMedia = 'agencyMedia',
  agencyBranding = 'agencyBranding',
  agencyInformation = 'agencyInformation',
  agencyAgencyRelationshipWithAllianceGroup = 'agencyAgencyRelationshipWithAllianceGroup',
  agencyAgencyInfoCarriers = 'agencyAgencyInfoCarriers',
  agencyAgencyInfoStatusActivity = 'agencyAgencyInfoStatusActivity',
  agencyAgencyInfoStatesLicensedIn = 'agencyAgencyInfoStatesLicensedIn',
  agencyContactInfoAddresses = 'agencyContactInfoAddresses',
  agencyContactInfoSocials = 'agencyContactInfoSocials',
  agencyContactInfoOfficeEmailAddresses = 'agencyContactInfoOfficeEmailAddresses',
  agencyContactInfoOfficePhoneNumbers = 'agencyContactInfoOfficePhoneNumbers',
  agencyContactInfoWebsites = 'agencyContactInfoWebsites',

  agentAdminister = 'agentAdminister',
  agentInformation = 'agentInformation',
  agentMedia = 'agentMedia',
  agentContactInfoAddresses = 'agentContactInfoAddresses',
  agentContactInfoSocials = 'agentContactInfoSocials',
  forceChangeLoginEmail = 'forceChangeLoginEmail',
  agentContactInfoEmailAddressesParent = 'agentContactInfoEmailAddressesParent',
  agentContactInfoEmailAddresses = 'agentContactInfoEmailAddresses',
  agentContactInfoPhoneNumbers = 'agentContactInfoPhoneNumbers',
  agentContactInfoWebsites = 'agentContactInfoWebsites',

  agentChangesHistory = 'agentChangesHistory',

  agentPersonalInformation = 'agentPersonalInformation',
  agentPersonalInfoAssociations = 'agentPersonalInfoAssociations',
  agentPersonalInfoDietaryConsiderations = 'agentPersonalInfoDietaryConsiderations',
  agentPersonalInfoFlightPreferences = 'agentPersonalInfoFlightPreferences',
  agentPersonalInfoSizesForFunStuff = 'agentPersonalInfoSizesForFunStuff',

  agentAgentInfoAgentPortal = 'agentAgentInfoAgentPortal',
  agentAgentInfoStatusActivity = 'agentAgentInfoStatusActivity',
  agentAgentInfoMga = 'agentAgentInfoMga',
  agentAgentInfoNeedToKnow = 'agentAgentInfoNeedToKnow',
  agentAgentInfoDepartmentOfInsuranceInfo = 'agentAgentInfoDepartmentOfInsuranceInfo',
  agentAgentInfoStatesLicensedIn = 'agentAgentInfoStatesLicensedIn',
  agentAgentInfoCarriers = 'agentAgentInfoCarriers',
  agentCampaignWizard = 'agentCampaignWizard',

  agentPermissions = 'agentPermissions',
  reportsGenerationPipeline = 'reportsGenerationPipeline',
  products = 'products',
  leadersBulletins = 'leadersBulletins',
  leadersBulletinsLock = 'leadersBulletinsLock',
  reportsViewerMgaSubmitted = 'reportsViewerMgaSubmitted',
  reportsViewerMgaPaid = 'reportsViewerMgaPaid',
  reportsViewerPersonalSubmitted = 'reportsViewerPersonalSubmitted',
  reportsViewerPersonalPaid = 'reportsViewerPersonalPaid',
  reportsViewerRmdSubmitted = 'reportsViewerRmdSubmitted',
  reportsViewerRmdPaid = 'reportsViewerRmdPaid',
  reportsViewerComparison = 'reportsViewerComparison',
  reportsViewerProductionHistory = 'reportsViewerProductionHistory',

  //** PORTAL: **//
  agentPortalParent = 'agentPortalParent',
  adminToolsMenuParent = 'adminToolsMenuParent',
  campaignWizardParent = 'campaignWizardParent',
  conferenceWizardParent = 'conferenceWizardParent',

  agentPortal = 'agentPortal',
  agentPortalEditPicture = 'agentPortalEditPicture',
  agentPortalSalesGoal = 'agentPortalSalesGoal',
  agentPortalContactInfo = 'agentPortalContactInfo',
  agentPortalPersonalInfo = 'agentPortalPersonalInfo',
  agentPortalPermissions = 'agentPortalPermissions',
  agentPortalMedia = 'agentPortalMedia',
  agentPortalInformation = 'agentPortalInformation',
  agentPortalForceChangeLoginEmail = 'agentPortalForceChangeLoginEmail',
  // Personal Menu
  campaignWizard = 'campaignWizard',
  conferenceWizard = 'conferenceWizard',
  ordersEditor = 'ordersEditor',
  contestsEditor = 'contestsEditor',
  carriersReportsAdmin = 'carriersReportsAdmin',
  // Admin Tools Menu
  adminToolsMenu = 'adminToolsMenu',

  settingsGoals = 'settingsGoals',
  settingsErrors = 'settingsErrors',

  contentAnnouncements = 'contentAnnouncements',
  contentCalendar = 'contentCalendar',
  contentCards = 'contentCards',
  contentForms = 'contentForms',
  contentMacros = 'contentMacros',
  contentMenu = 'contentMenu',
  contentPages = 'contentPages',
  contentSplashScreens = 'contentSplashScreens',
  contentVideos = 'contentVideos',

  storeOrders = 'storeOrders',
  storeProducts = 'storeProducts',
  storeCoupons = 'storeCoupons',

  conferenceWizardRSVP = 'conferenceWizardRSVP',
  conferenceWizardPersonalInfo = 'conferenceWizardPersonalInfo',
  conferenceWizardExcursions = 'conferenceWizardExcursions',
  conferenceWizardHotelReservation = 'conferenceWizardHotelReservation',
  conferenceWizardGuestRegistration = 'conferenceWizardGuestRegistration',
  conferenceWizardFlightInformation = 'conferenceWizardFlightInformation',
  conferenceWizardConfirmation = 'conferenceWizardConfirmation',
  conferenceWizardPayment = 'conferenceWizardPayment',
  conferenceWizardRegistrationSummary = 'conferenceWizardRegistrationSummary',

  campaignWizardPickYourWebsite = 'campaignWizardPickYourWebsite',
  campaignWizardAddYourContactInfo = 'campaignWizardAddYourContactInfo',
  campaignWizardAddYourBio = 'campaignWizardAddYourBio',
  campaignWizardAddSocialMedia = 'campaignWizardAddSocialMedia',
  campaignWizardAddYourLogoHeadshot = 'campaignWizardAddYourLogoHeadshot',
  campaignWizardAddAppointment = 'campaignWizardAddAppointment',
  campaignWizardAddExternalLinks = 'campaignWizardAddExternalLinks',
  campaignWizardSummary = 'campaignWizardSummary',

  impersonateAdminLevel = 'impersonateAdminLevel',
  paymentsTestMode = 'paymentsTestMode',

  pageBuilderGlobalStyles = 'pageBuilderGlobalStyles',

  //** PWA PORTAL: **//
  pwaMapRoot = 'pwaMapRoot',
  pwaMap = 'pwaMap',
  pwaMapAgencyLevel = 'pwaMapAgencyLevel',
  pwaMapRMDLevel = 'pwaMapRMDLevel',
  pwaMapAGLevel = 'pwaMapAGLevel',

  // Dashboard
  dashboard = 'dashboard',

  // Dashboard widgets
  dashboardRevenueProjection = 'dashboardRevenueProjection',
}

export enum BackgroundEntity {
  portalAgencyManagement = 'portalAgencyManagement',
  portalAgentActivityStatus = 'portalAgentActivityStatus',
}

export const entityNameList = Object.keys(Entity);

export const administrationMenuEntityList: Entity[] = [
  Entity.administrationRoleManager,
  Entity.administrationErrorsManager,
  Entity.administrationLookupsManager,
  Entity.administrationReportsManager,
  Entity.administrationLogsManager,
  Entity.administrationTaskListManager,
  Entity.administrationImportRulesManager,
  Entity.agentSalesGoal,
  Entity.mgaSalesGoal,
  Entity.administrationGoogleAuthManager,
  Entity.administrationUserManager,
  Entity.administrationAuthStats,
  Entity.administrationMergeTool,
];

export const campaignMenuEntityList: Entity[] = [
  Entity.campaignServices,
  Entity.campaignTaskBoard,
  Entity.campaignTaskGrid,
];

export const notificationsHubMenuEntityList: Entity[] = [
  Entity.notificationsChannels,
  Entity.notificationsScheduler,
  Entity.notificationsTemplates,
  Entity.dynamicListGroups,
  Entity.dynamicSegmentsGroups,
];
